import { useSelector } from 'react-redux';

import { FormBuilder } from 'components/Layouts/Form/FormBuilder';
import { pageDataSelector } from 'store/page/selectors';

import PageButtons from '../../PageTypes/shared/PageButtons';
import { AILoaderWrapper } from '../common/AIPageGeneration/AILoaderWrapper';
import { PageGenerationProvider, usePageGenerationContext } from '../common/AIPageGeneration/PageGenerationContext';
import Builder from './Builder';
import { useInlineEditor } from './functions';
import styles from './index.module.css';
import { getPageTypesConfig } from './pageTypesConfig';
import getNavLinks from './utils';

function Landing() {
  const page = useSelector(pageDataSelector);

  if (!page.type) return null;

  return (
    <PageGenerationProvider>
      <LandingInner />
    </PageGenerationProvider>
  );
}

export default Landing;

function LandingInner() {
  const page = useSelector(pageDataSelector);
  const { withNav, useMockData, CustomPage } = getPageTypesConfig(page.type);
  const { landingData } = useInlineEditor(useMockData(page));
  const navLinks = getNavLinks(landingData);
  const { cardState } = usePageGenerationContext();

  if (CustomPage) {
    return <CustomPage />;
  }

  if (!landingData) return null;

  return (
    <FormBuilder withNav={withNav} navLinks={navLinks} className={styles.formBuilder}>
      <AILoaderWrapper isLoading={cardState === 'loading'}>
        <Builder landingData={landingData.pages[0]} page={page} links={navLinks} />
        <PageButtons
          values={{
            ...landingData.pages[0],
            primaryImageId: landingData.pages[0].primaryImageId,
            primaryImageCoords: landingData.pages[0].primaryImageCoords,
          }}
        />
      </AILoaderWrapper>
    </FormBuilder>
  );
}
